export default "__VITE_ASSET__lKO5b5zH__"